import React from 'react';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import { WidgetRow, WidgetFooter, WidgetEmpty, Age, formatMoney, useGoTo } from './common';

const AwaitingApprovalWidget = ({ data }) => {
  const goTo = useGoTo();
  const items = data.items || [];
  return (
    <>
      {items.length === 0 && <WidgetEmpty>Nothing is waiting for your approval.</WidgetEmpty>}
      {items.map((i) => {
        const parts = [i.number, formatMoney(i.amount, i.currency), i.created_by_name].filter(Boolean);
        return (
          <WidgetRow
            key={`${i.kind}-${i.id}`}
            icon={faFileInvoiceDollar}
            tone="warn"
            title={i.partner_name || i.number || i.kind_label}
            subtitle={`${i.kind_label}${parts.length ? ' · ' : ''}${parts.join(' · ')}`}
            right={<Age>{i.age_label}</Age>}
            onClick={() => goTo(i.url)}
          />
        );
      })}
      <WidgetFooter label="Open Financials" url={data.url} />
    </>
  );
};

export default AwaitingApprovalWidget;
